import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {AuthService} from './auth.service';
import {RoleService} from './role.service';

@Injectable({
  providedIn: 'root'
})
export class SettingsAccessGuardService implements CanActivate {
  constructor(
    private authService: AuthService,
    private roleService: RoleService,
    private router: Router,
    private toastr: ToastrService
  ) {}

    canActivate(_route: ActivatedRouteSnapshot): boolean {
        if (!this.authService.isAuthenticated()) {
            void this.router.navigate(['/login']);
            return false;
        }

    const groups = this.authService.getCurrentUserInfo()?.role;
    if (this.roleService.canAccessAlertSettings(groups)) {
      return true;
    }
    this.toastr.error('You do not have permission to access these settings.', 'Access Denied');
    this.router.navigate(['/dashboard']);
    return false;
  }
}
